// removed by extract-text-webpack-plugin
module.exports = {"reply-container":"_1pfpcaqCuBUQjSwVdj51KS","replier":"vxVJVX_KNraG3WOg5EzCH","replier-pic":"_3dH56iiynjHqicDkpc2n7w","replier-user-name":"_1h3pISwhe3DMVWAN6U0FbA","reply-content":"_1dADrJcr0FX7D9LFPbTWqE","date":"_3Lxo7_Ac_N63WoQRUz7txl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/ReviewReply.scss
// module id = 252
// module chunks = 0 2 9